enum ZipInActionEnum {
	save = 'save',
	forget = 'forget'
}

export default ZipInActionEnum;
